export default __webpack_public_path__ + "assets/images/4e514d230cdbe35a4dd41ee80caf41f3.png";